// extracted by mini-css-extract-plugin
module.exports = {"ctaMargin":"VTCLyon_ctaMargin__jObRx"};